"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PresenterKnockItem = require("./PresenterKnockItem");
Object.keys(_PresenterKnockItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PresenterKnockItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PresenterKnockItem[key];
    }
  });
});